
import DataTable from "react-data-table-component";
export default function TableUserLog({ data, pending, totalRows, page, onChangeRowsPerPage, onChangePage }) {

    const columns = [
        {
            name: "#",
            selector: (row) => row.id,
            width: '80px'
        },
        {
            name: "Name",
            selector: (row) => row.name
        },
        {
            name: "Activity",
            selector: (row) => row.atvy,
            cell: (row) => (
                <div style={{
                    maxHeight: '180px',
                    overflowY: 'auto',
                    whiteSpace: 'pre-wrap'
                }}>
                    {row.atvy}
                </div>
            )
        },
        {
            name: "Ip address",
            selector: (row) => row.ip
        },
        {
            name: "Created at",
            selector: (row) => row.crea
        },
    ];

    return (

        <DataTable
            columns={columns}
            data={data}
            progressPending={pending}
            paginationTotalRows={totalRows}
            paginationDefaultPage={page}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
            pagination
            paginationServer
        />
    );
}
